module.exports = __webpack_public_path__ + "img/manual-icon.c24ac4e0.svg";